import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { isJwtExpired } from 'jwt-check-expiration';

const PrivateResource = () => {
  const [message, setMessage] = useState('');
  const token = sessionStorage.getItem('jwtToken'); // Retrieve JWT token from localStorage
    console.log('JWT token retrieved:', token);
    //console.log('isExpired is:', isJwtExpired(token));
  

  useEffect(() => {

    //const apiUrl = process.env.REACT_APP_API_URL;
    
    

    
    

    // Make an HTTP GET request to the backend API
    // axios.get('http://muvitapp.com:8080/users/privateresource', 
    axios.get('http://muvitapp.com/webapp2/', 
      {
        headers: {
          "Authorization": `Bearer ${token}`,  // Attach JWT token to Authorization header
          
          //"Content-Type": "application/json"    // Optional: You can specify other headers if needed
        }
      }
    )
    
      .then(response => {
        setMessage(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      });
  }, []);

  
    if(token==null || isJwtExpired(token)) {
      return(
          <p className="text-center">You need to be logged in.</p>
      )
    }

    
  return (
    <div>
      <h1>Message from Backend: {message}</h1>
    </div>
  );
};

export default PrivateResource;
